import { render } from "./A00016.vue?vue&type=template&id=84c471dc&ts=true"
import script from "./A00016.vue?vue&type=script&lang=ts"
export * from "./A00016.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__